import { useDynamicModule } from "@grandvisionhq/utils";
const loadModule = async () => {
  const { GoogleMap, InfoWindow, MarkerClusterer, LoadScript, Marker } = await import(
    /* webpackChunkName: "react-google-maps" */
    "@react-google-maps/api"
  );
  return { GoogleMap, InfoWindow, MarkerClusterer, LoadScript, Marker };
};
const useGoogleMapsModule = () => useDynamicModule(loadModule, "@react-google-maps/api", []);
export {
  useGoogleMapsModule
};
//# sourceMappingURL=external-module.js.map
